/**
 * Sanitize optional CSV download base name (no path, no .csv in payload).
 * For Media Devoted | Created By Ciro Autiero
 */

const MAX_BASE_LEN = 80;

function stripCsvExtension(s: string): string {
  return s.replace(/\.csv$/i, '').trim();
}

/** Null → caller uses default tab/date filename. */
export function sanitizeCsvDownloadBaseName(raw: string | undefined): string | null {
  if (raw == null) return null;
  let s = stripCsvExtension(raw);
  if (!s) return null;
  s = s.replace(/[^a-zA-Z0-9._\- ]+/g, '-').replace(/^-+|-+$/g, '');
  if (!s) return null;
  return s.length > MAX_BASE_LEN ? s.slice(0, MAX_BASE_LEN) : s;
}
